import { defineComponent as _defineComponent } from 'vue'
import { useCourseBuilderStore } from '@/stores/trainings/courseBuilder';
  import TextComponent from '@/ui/components/trainings/courseBuilder/components/TextComponent.vue';
  import { storeToRefs } from 'pinia';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'ComponentEditor',
  setup(__props) {

  const courseBuilder = useCourseBuilderStore();
  const { activeItem } = storeToRefs(courseBuilder);

  const handleUpdateTitle = (title: string) => {
    courseBuilder.updateItemTitle(activeItem.value!, title);
  };

  const handleUpdateDescription = (description: string) => {
    courseBuilder.updateItemDescription(activeItem.value!, description);
  };

return { __sfc: true,courseBuilder, activeItem, handleUpdateTitle, handleUpdateDescription, TextComponent }
}

})